import { useNavigate } from "react-router-dom";
import { MessagesSquare } from "lucide-react";
import { usePermissions } from "@/hooks/usePermissions";
import { useConversationsPendingCount } from "@/hooks/useWhatsAppFloating";

/**
 * Acceso directo a CONVERSACIONES en la barra superior (14-sep-2026,
 * petición de Luis): icono de chat junto a la campana con contador rojo de
 * conversaciones que ESPERAN A UNA PERSONA (modo humano con mensajes sin
 * leer — las que lleva Carmen no suman: no piden acción). Mismo patrón de
 * badge que la campana; el endpoint /whatsapp-conversations/count nunca da
 * 500 (badge nunca rompe el navbar).
 *
 * Visible con el mismo criterio que el ítem del menú lateral: owner/admin
 * siempre; staff solo con el permiso "conversaciones:gestionar".
 */
export default function ConversationsQuickAccess() {
  const navigate = useNavigate();
  const { can } = usePermissions();
  const allowed = can("conversaciones:gestionar");
  const { unread: count } = useConversationsPendingCount(allowed);

  if (!allowed) return null;

  return (
    <button
      onClick={() => navigate("/conversations")}
      title="Conversaciones"
      aria-label={
        count > 0 ? `Conversaciones: ${count} sin leer` : "Conversaciones"
      }
      className="relative p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
    >
      <MessagesSquare className="w-5 h-5" />
      {count > 0 && (
        <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 bg-red-500 text-white text-[11px] font-bold rounded-full flex items-center justify-center">
          {count > 9 ? "9+" : count}
        </span>
      )}
    </button>
  );
}
